import React from 'react'
import SentNotificationsListContainer from 'containers/Notifications/SentNotificationsList'

const SentNotificationsListPage = () => <SentNotificationsListContainer />

export default SentNotificationsListPage
